document.addEventListener('click',e=>{
  const menuBtn=e.target.closest('[data-menu-toggle]');
  if(menuBtn){
    const menu=document.querySelector('[data-mobile-menu]');
    if(menu){
      const open=menu.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded',open?'true':'false');
    }
  }
  const subBtn=e.target.closest('[data-submenu-toggle]');
  if(subBtn){
    const item=subBtn.closest('.mobile-menu-item');
    const submenu=item && item.querySelector('[data-mobile-submenu]');
    if(submenu){
      const open=subBtn.getAttribute('aria-expanded')==='true';
      document.querySelectorAll('[data-submenu-toggle][aria-expanded="true"]').forEach(btn=>{
        if(btn!==subBtn){btn.setAttribute('aria-expanded','false'); const sm=btn.closest('.mobile-menu-item')?.querySelector('[data-mobile-submenu]'); if(sm) sm.classList.remove('is-open');}
      });
      subBtn.setAttribute('aria-expanded',String(!open));
      submenu.classList.toggle('is-open',!open);
    }
  }
});

document.addEventListener('click',function(e){
  const b=e.target.closest('[data-filter-toggle]');
  if(!b)return;
  const panel=document.querySelector('[data-collection-filters]');
  if(panel)panel.classList.toggle('is-open');
});


(function(){
  const drawer = document.querySelector('[data-clean-cart-drawer]');
  if(!drawer) return;
  const body = drawer.querySelector('[data-cart-drawer-body]');
  const footer = drawer.querySelector('[data-cart-drawer-footer]');
  const total = drawer.querySelector('[data-cart-drawer-total]');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'es-ES',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}).format((Number(cents)||0)/100);
  const esc = value => String(value ?? '').replace(/[&<>'"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));

  function openDrawer(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; }
  function closeDrawer(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }

  async function getCart(){
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{'Accept':'application/json'}});
    if(!response.ok) throw new Error('cart');
    return response.json();
  }
  function renderCart(cart){
    if(!cart.items.length){
      body.innerHTML='<div class="clean-cart-drawer__empty">Tu carrito está vacío</div>';
      footer.hidden=true;
      return;
    }
    body.innerHTML=cart.items.map((item,index)=>{
      const img=item.image ? `<img class="clean-cart-item__image" src="${esc(item.image)}&width=220" alt="${esc(item.product_title)}" loading="lazy">` : '<div class="clean-cart-item__image"></div>';
      const variant=item.variant_title && item.variant_title!=='Default Title' ? `<div class="clean-cart-item__variant">${esc(item.variant_title)}</div>` : '';
      return `<div class="clean-cart-item">
        <a href="${esc(item.url)}">${img}</a>
        <div><a class="clean-cart-item__title" href="${esc(item.url)}">${esc(item.product_title)}</a>${variant}<div class="clean-cart-item__qty"><button type="button" data-cart-change="${index+1}" data-cart-qty="${Math.max(0,item.quantity-1)}" aria-label="Reducir">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${index+1}" data-cart-qty="${item.quantity+1}" aria-label="Aumentar">+</button></div></div>
        <div class="clean-cart-item__price">${money(item.final_line_price)}</div>
      </div>`;
    }).join('');
    total.textContent=money(cart.total_price);
    footer.hidden=false;
  }
  async function refreshCart(open=true){
    drawer.classList.add('is-loading');
    try{ const cart=await getCart(); renderCart(cart); if(open) openDrawer(); }
    finally{ drawer.classList.remove('is-loading'); }
  }

  document.addEventListener('click', async e=>{
    const opener=e.target.closest('[data-cart-open]');
    if(opener){ e.preventDefault(); refreshCart(true); return; }
    if(e.target.closest('[data-cart-close]')){ e.preventDefault(); closeDrawer(); return; }
    const change=e.target.closest('[data-cart-change]');
    if(change){
      e.preventDefault(); drawer.classList.add('is-loading');
      try{
        await fetch((window.Shopify?.routes?.root || '/')+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(change.dataset.cartChange),quantity:Number(change.dataset.cartQty)})});
        const cart=await getCart(); renderCart(cart);
      } finally { drawer.classList.remove('is-loading'); }
    }
  });
  document.addEventListener('keydown',e=>{ if(e.key==='Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

  document.addEventListener('submit', async e=>{
    const form=e.target.closest('form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    const submit=form.querySelector('[type="submit"]');
    if(submit) submit.disabled=true;
    try{
      const response=await fetch(form.action,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
      if(!response.ok) throw new Error('add');
      await refreshCart(true);
    } catch(err){
      form.submit();
    } finally { if(submit) submit.disabled=false; }
  }, true);
})();

/* 1.9.7 — mobile footer advantages slider dots */
(function(){
  function initFooterFeatures(){
    document.querySelectorAll('[data-footer-features]').forEach(function(section){
      var slider=section.querySelector('[data-feature-slider]');
      var slides=Array.from(section.querySelectorAll('[data-feature-slide]'));
      var dots=Array.from(section.querySelectorAll('[data-feature-dot]'));
      if(!slider || slides.length < 2 || !dots.length || slider.dataset.sliderReady==='true') return;
      slider.dataset.sliderReady='true';
      var raf=0;
      function update(){
        raf=0;
        var width=slider.clientWidth || 1;
        var index=Math.round(slider.scrollLeft / width);
        index=Math.max(0,Math.min(index,dots.length-1));
        dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===index)});
      }
      slider.addEventListener('scroll',function(){if(!raf) raf=requestAnimationFrame(update)},{passive:true});
      window.addEventListener('resize',update,{passive:true});
      update();
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initFooterFeatures);
  else initFooterFeatures();
  document.addEventListener('shopify:section:load',initFooterFeatures);
})();
